const buildUrl = (router, extra) => {
  let url = router.asPath.split('?')[0];
  url += '?';
  Object.keys(extra).forEach((key) => {
    if (key === 'page' && extra.page < 2) return;
    if (!extra[key]) return;
    if (url[url.length - 1] !== '?') {
      url += '&';
    }
    url += `${key}=${extra[key]}`;
  });
  if (url[url.length - 1] === '?') {
    url = url.substring(0, url.length - 1);
  }
  return url;
};

/* eslint-disable */
const searchAsObject = (search) => {
  if (!search) return {};
  return JSON.parse('{"' + decodeURI(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
    + '"}');
};
/* eslint-enable */

const getBasePath = (router) => {
  const origin = typeof window !== 'undefined' && window.location.origin ? window.location.origin : '';
  return `${origin}${router.basePath}`
};

const urlHelper = {
  buildUrl,
  searchAsObject,
  getBasePath,
};

export default urlHelper;
